import { render, staticRenderFns } from "./StatusFilter.vue?vue&type=template&id=c8228a74&scoped=true"
import script from "./StatusFilter.vue?vue&type=script&lang=js"
export * from "./StatusFilter.vue?vue&type=script&lang=js"
import style0 from "./StatusFilter.vue?vue&type=style&index=0&id=c8228a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8228a74",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/extranet/StatusFilter.vue
// module id = 716
// module chunks = 31